module.exports = __webpack_public_path__ + "img/118.d78839c3.jpg";